export default {"src":"/_next/static/media/icon-facebook.f0b9b25c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};